import "./TmcWarningDialogComponent.scss";
import template from "./TmcWarningDialogComponent.html";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {CurrentUserService} from "../../../../../../services/user/CurrentUserService";
import {ReplaySubject} from "rxjs";
import {TmcWarningAction} from "../models/TmcWarningAction";

export const TmcWarning = "tfTmcWarningDialog";

export function tmcWarning(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<"
        },
        controllerAs: "ctrl",
        controller: TmcWarningDialogComponentController
    };
}

export class TmcWarningDialogComponentController implements IOnInit, IOnDestroy {

    public readonly modalInstance: IModalInstanceService;

    public readonly hasWatchedVideo$ = new ReplaySubject<boolean>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly currentUserService: CurrentUserService) {

    }

    public $onInit(): void {
        this.currentUserService
            .current
            .map((user) => user.hasWatchedTmcVideo())
            .takeUntil(this.destroyed$)
            .subscribe((hasWatched) => this.hasWatchedVideo$.next(hasWatched));
    }

    public watchedVideo() {
        this.currentUserService.setWatchedTmcVideo();
    }

    public tradeAsTmc() {
        this.modalInstance.close(TmcWarningAction.TRADE_TMC);
    }

    public tradeAsSingles() {
        this.modalInstance.close(TmcWarningAction.TRADE_SINGLES);
    }

    public cancel() {
        this.modalInstance.dismiss();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
